module.exports = __webpack_public_path__ + "static/media/vis15.73b55619.jpeg";